export const getStudies = `query MyQuery($page: Int, $pageSize: Int ){
  getStudies(page: $page, pageSize: $pageSize) {
    AnimalSpecies
    AnimalStrain
    Category
    CreatedByUserID
    CreatedDate
    Description
    EndDate
    ID
    ModifiedByUserID
    ModifiedDate
    Name
    Sponsor
    StartDate
    Status
    TestFacility
    AnimalGroups {
      Animals {
        AnimalGroupID
        CreatedByUserID
        CreatedDate
        Description
        ID
        ModifiedByUserID
        ModifiedDate
        Name
        ProcedureNotes
        Sex
        Species
        Strain
      }
      Administration
      CreatedByUserID
      CreatedDate
      Dose
      ID
      ModifiedByUserID
      Name
      ModifiedDate
      SacrificePeriod
      StudyID
      TreatmentTime
      TreatmentType
    }
    Organs {
      CreatedByUserID
      ID
      CreatedDate
      ModifiedByUserID
      ModifiedDate
      Organ
      System
    }
  }
}
`;